import { ref } from 'vue'
import { defineStore } from 'pinia'
import { RoleAuthData, ExpenseAuth, ManageAuth } from '@/interface/api/role'

export const authPinia = defineStore('authPinia', () => {
  const auth = ref<RoleAuthData | null>(null)
  const piaoshuiAuth = ref<ExpenseAuth | null>(null)
  const manageAuth = ref<ManageAuth | null>(null)
  function setAuth(data: RoleAuthData | null) {
    auth.value = data
    if (data) {
      piaoshuiAuth.value = data.piaoshui
      manageAuth.value = data.manage
    } else {
      piaoshuiAuth.value = null
      manageAuth.value = null
    }
  }
  return { auth, manageAuth, piaoshuiAuth, setAuth }
})
